<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <!-- content-header component -->
    <app-content-header [contentHeader]="contentHeader"></app-content-header>

    @if (page) {
      <section>
        <div class="card">
          <div class="row">
            <div class="col-6">
              <div class="show-entries-container">
                <label
                  >Zeige
                  <ng-select
                    [clearable]="false"
                    [searchable]="false"
                    [formControl]="filter.get('limit') | formControl">
                    <ng-option [value]="10">10</ng-option>
                    <ng-option [value]="25">25</ng-option>
                    <ng-option [value]="50">50</ng-option>
                    <ng-option [value]="100">100</ng-option>
                  </ng-select>
                  Einträge</label
                >
              </div>
            </div>
            <div class="col-6">
              <div class="datatable-add-button">
                <button
                  type="button"
                  rippleEffect
                  (click)="openModal()">
                  <i
                    data-feather="plus"
                    class="datatable-add-button-icon"></i
                  ><span class="datatable-add-button-text">Bericht hinzufügen</span>
                </button>
              </div>
            </div>
          </div>
          <ngx-datatable
            [rows]="page.items"
            [reorderable]="false"
            rowHeight="auto"
            class="bootstrap core-bootstrap"
            columnMode="force"
            [scrollbarH]="true"
            [count]="page.totalItems ?? 0"
            [offset]="page.currentPage - 1"
            [limit]="page.itemsPerPage"
            [externalPaging]="true"
            (page)="setPage($event)"
            [externalSorting]="true"
            (sort)="onSort($event)">
            <ngx-datatable-column
              [width]="75"
              prop="id"
              name=""
              [sortable]="false">
              <ng-template
                let-value="value"
                let-row="row"
                ngx-datatable-cell-template>
                <div class="datatable-buttons">
                  @if (!row.deletedAt) {
                    <div
                      title="ansehen"
                      (click)="openViewModal({ id: value })"
                      class="clickable-icon">
                      <i data-feather="eye"></i>
                    </div>
                    <a
                      title="bearbeiten"
                      [routerLink]="[]"
                      [queryParams]="getOpenModalParams(value)"
                      class="clickable-icon">
                      <i data-feather="edit"></i>
                    </a>
                    <div
                      title="löschen"
                      class="clickable-icon-danger"
                      (click)="delete(value)">
                      <i data-feather="trash"></i>
                    </div>
                  } @else {
                    @if (CaslAction.Restore | permission: EntityTyp.Report) {
                      @if (row.deletedAt) {
                        <div class="datatable-buttons">
                          <div
                            title="Wiederherstellen"
                            class="clickable-icon"
                            (click)="restore(value)">
                            <i data-feather="plus-circle"></i>
                          </div>
                        </div>
                      }
                    }
                  }
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              prop="office"
              name="Bericht für">
              <ng-template
                let-column="column"
                ngx-datatable-header-template
                let-sort="sortFn"
                let-sortDir="sortDir">
                <love-it-list-header-cell
                  [column]="column"
                  [sortFunc]="sort"
                  [sortDir]="sortDir"></love-it-list-header-cell>
                <ng-select
                  [items]="offices"
                  [formControl]="filter.get('officeId') | formControl"
                  bindValue="id"
                  bindLabel="name"></ng-select>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              prop="affectedClients"
              name="Relevant für Klient:innen"
              [sortable]="false">
              <ng-template
                let-column="column"
                ngx-datatable-header-template>
                <love-it-list-header-cell [column]="column"></love-it-list-header-cell>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Suche..."
                  [formControl]="filter.get('affectedClientsSearch') | formControl" />
              </ng-template>
              <ng-template
                ngx-datatable-cell-template
                let-value="value">
                {{ value }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              prop="createdDate"
              name="Erstelldatum">
              <ng-template
                let-column="column"
                ngx-datatable-header-template
                let-sort="sortFn"
                let-sortDir="sortDir">
                <love-it-list-header-cell
                  [column]="column"
                  [sortFunc]="sort"
                  [sortDir]="sortDir"></love-it-list-header-cell>
                <love-it-date-range-picker [formControl]="createdDate"></love-it-date-range-picker>
              </ng-template>
              <ng-template
                ngx-datatable-cell-template
                let-value="value">
                {{ value | date }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              prop="updatedDate"
              name="Änderungsdatum">
              <ng-template
                let-column="column"
                ngx-datatable-header-template
                let-sort="sortFn"
                let-sortDir="sortDir">
                <love-it-list-header-cell
                  [column]="column"
                  [sortFunc]="sort"
                  [sortDir]="sortDir"></love-it-list-header-cell>
                <love-it-date-range-picker [formControl]="updatedDate"></love-it-date-range-picker>
              </ng-template>
              <ng-template
                ngx-datatable-cell-template
                let-value="value">
                {{ value | date }}
              </ng-template>
            </ngx-datatable-column>
            @if (hasUmFOffice) {
              <ngx-datatable-column
                prop="subject"
                name="Betreff"
                [sortable]="false">
                <ng-template
                  let-column="column"
                  ngx-datatable-header-template
                  let-sort="sortFn"
                  let-sortDir="sortDir">
                  <love-it-list-header-cell
                    [column]="column"
                    [sortFunc]="sort"
                    [sortDir]="sortDir"></love-it-list-header-cell>
                  <ng-select
                    [items]="subjects"
                    [formControl]="filter.get('subject') | formControl"
                    [searchable]="false"
                    bindValue="value"
                    bindLabel="display"></ng-select>
                </ng-template>
                <ng-template
                  ngx-datatable-cell-template
                  let-value="value">
                  {{ value }}
                </ng-template>
              </ngx-datatable-column>
            }
            @if (isAdmin || hasGVSOffice) {
              <ngx-datatable-column
                prop="housing"
                name="Wohnung">
                <ng-template
                  let-column="column"
                  ngx-datatable-header-template
                  let-sort="sortFn"
                  let-sortDir="sortDir">
                  <love-it-list-header-cell
                    [column]="column"
                    [sortFunc]="sort"
                    [sortDir]="sortDir"></love-it-list-header-cell>
                  <ng-select
                    [items]="housings"
                    [formControl]="filter.get('housingId') | formControl"
                    bindValue="id"
                    bindLabel="name"></ng-select>
                </ng-template>
              </ngx-datatable-column>
            }
            @if (isAdmin) {
              <ngx-datatable-column
                prop="deletedAt"
                name="Gelöscht"
                [sortable]="false">
                <ng-template
                  let-column="column"
                  ngx-datatable-header-template
                  let-sort="sortFn"
                  let-sortDir="sortDir">
                  <love-it-list-header-cell
                    [column]="column"
                    [sortFunc]="sort"
                    [sortDir]="sortDir"></love-it-list-header-cell>
                  <love-it-select-boolean [booleanFc]="filter.get('deleted') | formControl"></love-it-select-boolean>
                </ng-template>
                <ng-template
                  ngx-datatable-cell-template
                  let-value="value">
                  <love-it-display-boolean [value]="value"></love-it-display-boolean>
                </ng-template>
              </ngx-datatable-column>
            }
          </ngx-datatable>
          <div class="flex flex-row justify-content-between">
            <div class="flex flex-column">
              <div class="datatable-add-button">
                <button
                  type="button"
                  rippleEffect
                  (click)="openViewModal()">
                  <i
                    data-feather="eye"
                    class="datatable-add-button-icon"></i>
                  <span class="datatable-add-button-text">Zusammenfassung</span>
                </button>
              </div>
            </div>
            <div class="flex flex-column">
              <div class="datatable-add-button">
                <button
                  type="button"
                  rippleEffect
                  [disabled]="isExportingWord"
                  (click)="exportWordSummary()">
                  <span [hidden]="isExportingWord">
                    <i
                      data-feather="file-text"
                      class="datatable-add-button-icon"></i>
                  </span>
                  @if (isExportingWord) {
                    <span
                      class="spinner-border spinner-border-sm datatable-add-button-icon"
                      role="status"
                      aria-hidden="true"></span>
                  }
                  <span class="datatable-add-button-text">
                    {{ isExportingWord ? "Word-Datei wird erstellt…" : "Zusammenfassung als Word exportieren" }}
                  </span>
                </button>
              </div>
            </div>
            <div class="flex flex-column">
              <label style="width: 250px; margin: 0 1rem">
                Vorfallsliste für:
                <ng-select
                  [items]="offices"
                  [formControl]="vorfallslisteOfficeFilterFormControl"
                  bindValue="id"
                  bindLabel="name"></ng-select>
              </label>
              <div class="datatable-add-button">
                <button
                  type="button"
                  rippleEffect
                  (click)="downloadVorfallsliste()"
                  [disabled]="!vorfallslisteOfficeFilterFormControl.value">
                  <i
                    data-feather="table"
                    class="datatable-add-button-icon"></i>
                  <span class="datatable-add-button-text">Vorfallsliste herunterladen</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    }
  </div>
</div>
